<template>
  <el-dialog
    class="cert-file-modal"
    top="32px"
    title="证书详情"
    :visible.sync="visible"
    width="560px">
    <iframe
      class="file-frame"
      :src="url"
      frameborder="0"></iframe>
  </el-dialog>
</template>
<script>
export default {
  name: 'CertFileModal',
  data() {
    return { url: '', visible: false }
  },
  methods: {
    open(url) {
      this.url = url
      this.visible = true
    }
  }
}
</script>
<style lang="stylus" scoped src="./cert-file-modal.styl"></style>
